import type { PermissionSort, PermissionSortField } from "./permissions.types";

/** Ordem de quando nenhuma coluna foi escolhida: Nome A–Z (HU técnica 898). */
export const DEFAULT_PERMISSION_SORT: PermissionSort = { field: "nome", direction: "asc" };

const SORT_FIELDS: readonly PermissionSortField[] = ["codigo", "modulo", "nome", "descricao"];

export function isPermissionSortField(value: unknown): value is PermissionSortField {
  return SORT_FIELDS.includes(value as PermissionSortField);
}
